export const GA_MEASUREMENT_ID = 'G-ES40CBLJWB';
export const GA_PRODUCTION_HOST = 'unaffectedhealthcare.in';

// Must stay in sync with the opt-out regex in public/index.html.
const PRIVATE_PATH_RE = /^\/(dashboard|ops|doctor|admin|view-backup)(\/|$)|^\/login\/./;

export function isTrackedPath(pathname) {
  return !PRIVATE_PATH_RE.test(String(pathname || '/'));
}

export function trackPageView(pathname) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (window.location.hostname !== GA_PRODUCTION_HOST) return;

  const tracked = isTrackedPath(pathname);
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = !tracked;
  if (!tracked) return;

  window.gtag('event', 'page_view', {
    page_path: pathname,
    page_location: `${window.location.origin}${pathname}`,
    page_title: document.title,
  });
}
